module.exports = __webpack_public_path__ + "img/404.deca155a.svg";